function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import changeReducerFactory from './factories/changeReducerFactory';
import contentChangeReducerFactory from './factories/contentChangeReducerFactory';
import detailReducerFactory from './factories/detailReducerFactory';
import entityReducerFactory from './factories/entityReducerFactory';
import reportConstants from '../constants/reportConstants';
import uploadReducerFactory from './factories/uploadReducerFactory';
import applyReducer, { reduceReducers } from './applyReducer';
const entityReducer = entityReducerFactory('report');
const changeReducer = changeReducerFactory('report');
const contentChangeReducer = contentChangeReducerFactory('report');
const detailReducer = detailReducerFactory('report');
const uploadReducer = uploadReducerFactory('report');
const initState = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, detailReducer.initState), entityReducer.initState), changeReducer.initState), contentChangeReducer.initState), uploadReducer.initState), {}, {
  formatEditing: false,
  formatInput: {},
  formatOutput: {},
  newReportID: null,
  permissions: {
    view: {
      exclude: ['read_only']
    },
    edit: {
      include: ['user_edit', 'job_edit']
    }
  }
});

// reducers
const createSuccess = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  newReportID: action.data.id,
  // clear the query, which determines if index view is loaded
  indexQuery: _objectSpread(_objectSpread({}, state.indexQuery), {}, {
    initialized: false
  })
});
const render = state => _objectSpread(_objectSpread({}, state), {}, {
  loading: true
});

// This way we can handle the error in the component for the active entity
const renderFail = state => _objectSpread(_objectSpread({}, state), {}, {
  loading: false
});

// replace the existing report in stores with the new report WITH signedURL
const renderSuccess = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  active: action.data,
  loading: false
});
const showSuccess = state => _objectSpread(_objectSpread({}, state), {}, {
  error: null,
  newReportID: null,
  pendingChanges: false,
  loading: false
});
const updateStatus = (state, action) => {
  const reportData = action.data;
  const {
    active
  } = state;
  const list = state.list.splice(0);

  // only handle report.active if it is set
  let newActive = JSON.parse(JSON.stringify(active));
  if (newActive && newActive.id) {
    reportData.forEach(updatedReport => {
      if (newActive.id === updatedReport.id) {
        newActive.statusName = updatedReport.statusName;
        newActive.statusDate = updatedReport.statusDate;
        if (updatedReport.statusName === 'Deleted') {
          newActive = {};
        }
      }
    });
  }

  // always update the list
  const updatedList = [];
  list.forEach(report => {
    let updateValues = {};
    let isDeleted = false;
    reportData.forEach(updatedReport => {
      if (report.id === updatedReport.id) {
        isDeleted = updatedReport.statusName === 'Deleted';
        updateValues = {
          statusName: updatedReport.statusName,
          statusDate: updatedReport.statusDate
        };
      }
    });
    if (!isDeleted) {
      // Deleted Reports should not be stored in the list
      updatedList.push(_objectSpread(_objectSpread({}, report), updateValues));
    }
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    active: newActive,
    list: updatedList
  });
};
const reducers = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, detailReducer.reducers), entityReducer.reducers), changeReducer.reducers), contentChangeReducer.reducers), uploadReducer.reducers), {}, {
  [reportConstants.CREATE_SUCCESS]: createSuccess,
  [reportConstants.RENDER]: render,
  [reportConstants.RENDER_FAILURE]: renderFail,
  [reportConstants.RENDER_SUCCESS]: renderSuccess,
  [reportConstants.SAVE_ALL_SUCCESS]: reduceReducers(changeReducer.reducers[reportConstants.SAVE_ALL_SUCCESS], updateStatus),
  [reportConstants.SHOW_SUCCESS]: reduceReducers(contentChangeReducer.reducers[reportConstants.SHOW_SUCCESS], showSuccess),
  [reportConstants.NOOP]: state => state
});
export default applyReducer(reducers, initState);